import { render } from "./AddMarchand.vue?vue&type=template&id=36ae19cc&ts=true"
import script from "./AddMarchand.vue?vue&type=script&lang=ts"
export * from "./AddMarchand.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__